import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.header`
  width: 100%;
  padding: 24px 16px;
  background-color: ${theme.colors.green2};
  border-radius: 0px 0px 40px 40px;
  position: relative;
  @media (min-width: 768px) {
    //height: 20%;
    padding: 24px 100px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
